import Repository from '../axios'
import {defaultPagination} from "../constants/config";
import staff from "../apis/staff";

const resource = "/supplier/raw_materials";
export default {

  createRawMaterial(payload) {
    return Repository.post(`/admin${resource}`, payload)
  },
  getRawMaterialStatus(id) {
    return Repository.get(`/admin/supplier/raw_material/get-status/${id}`)
  },
  getRawMaterialDetails(id) {
    return Repository.get(`/admin${resource}/${id}`)
  },
  updateRawMaterialDetails(id, payload) {
    return Repository.put(`/admin${resource}/${id}`, payload)
  },
  getRawMaterialsBySite(id) {
    return Repository.get(`${resource}?manufacturing_site_id=${id}`)
  },
  getCategoryList() {
    return Repository.get(`/admin/supplier/raw_material_categories`)
  },
  rawMaterialStageChange(id, stage) {
    return Repository.put(`/admin/supplier/raw_material/${id}/${stage}`)
  },

  suspendRawMaterial(rm_id, suspend_level) {
    return Repository.put(`/admin/supplier/raw_material/${rm_id}/suspend_level_${suspend_level}`)
  },
  approveRawMaterial(id, payload) {
      return Repository.put(`/admin/supplier/raw_material/${id}/approve`, payload)
  },
  rejectRawMaterial(id) {
    return Repository.put(`/admin/supplier/raw_material/${id}/reject`)
  },
  reinstateRawMaterial(id) {
      return Repository.put(`/admin/supplier/raw_material/${id}/re_instate`)
  },
  getRawMaterialQCTests() {
    return Repository.get(`/admin/supplier/raw_material/company_data/q_c_tests`)
  },
  getFormulationsAttachedToRawMaterial(id, pageNumber = 1, filterQuery, pagination = defaultPagination){
    return Repository.get(`/admin/supplier/raw_material/${id}/attached-formulations?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getSingleRawMaterialQCTest(id) {
    return Repository.get(`/admin/supplier/raw_material/company_data/q_c_tests/${id}`)
  },
  createRawMaterialQCTest(payload) {
    return Repository.post(`/admin/supplier/raw_material/company_data/q_c_tests`, payload)
  },
  updateRawMaterialQCTest(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/company_data/q_c_tests/${id}`, payload)
  },

  // getAllManufacturerSites(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
  //   return Repository.get(`${resource}/sites?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  // },

  getRawMaterialBySupplierId(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/supplier/${id}/raw_materials?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getRawMaterialList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/supplier/raw_material/list?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getRawMaterialAcceptedList(pageNumber = 1, filterQuery = '', pagination = defaultPagination, sort = '', is_paginate = null) {
    let url = `/admin/supplier/raw_material/accepted_list?paginate=${pagination}&page=${pageNumber}&${filterQuery}`
    if (is_paginate !== null && (!filterQuery || filterQuery.indexOf('is_paginate') === -1)) {
      url += `&is_paginate=${is_paginate}`
    }
    return Repository.get(url)
  },
  getSimilarRawMaterialList(id, filterQuery) {
    return Repository.get(`/admin/supplier/similar_raw_material/${id}?${filterQuery}`)
  },

  getRawMaterialProductIdentity(id) {
    return Repository.get(`/admin/supplier/raw_material/products/${id}`)
  },
  CreateRawMaterialProductIdentity(payload) {
    return Repository.post(`/admin/supplier/raw_material/products`, payload)
  },
  UpdateRawMaterialProductIdentity(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/products/${id}`, payload)
  },

  getRawMaterialPCSParameters(id) {
    return Repository.get(`/admin/supplier/raw_material/parameters/${id}`)
  },
  CreateRawMaterialPCSParameters(payload) {
    return Repository.post(`/admin/supplier/raw_material/parameters`, payload)
  },
  UpdateRawMaterialPCSParameters(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/parameters/${id}`, payload)
  },

  getRawMaterialManufacturingProcess(id) {
    return Repository.get(`/admin/supplier/raw_material/processes/${id}`)
  },
  CreateRawMaterialManufacturingProcess(payload) {
    return Repository.post(`/admin/supplier/raw_material/processes`, payload)
  },
  UpdateRawMaterialManufacturingProcess(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/processes/${id}`, payload)
  },

  getRawMaterialProductAuthenticity(id) {
    return Repository.get(`/admin/supplier/raw_material/authenticities/${id}`)
  },
  CreateRawMaterialProductAuthenticity(payload) {
    return Repository.post(`/admin/supplier/raw_material/authenticities`, payload)
  },
  UpdateRawMaterialProductAuthenticity(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/authenticities/${id}`, payload)
  },

  getRawMaterialComposition(id) {
    return Repository.get(`/admin/supplier/raw_material/compositions/${id}`)
  },
  CreateRawMaterialComposition(payload) {
    return Repository.post(`/admin/supplier/raw_material/compositions`, payload)
  },
  UpdateRawMaterialComposition(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/compositions/${id}`, payload)
  },

  getRawMaterialAdditivePreservative(id) {
    return Repository.get(`/admin/supplier/raw_material/add_pres/${id}`)
  },
  CreateRawMaterialAdditivePreservative(payload) {
    return Repository.post(`/admin/supplier/raw_material/add_pres`, payload)
  },
  UpdateRawMaterialAdditivePreservative(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/add_pres/${id}`, payload)
  },

  getRawMaterialSolvent(id) {
    return Repository.get(`/admin/supplier/raw_material/solvents/${id}`)
  },
  CreateRawMaterialSolvent(payload) {
    return Repository.post(`/admin/supplier/raw_material/solvents`, payload)
  },
  UpdateRawMaterialSolvent(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/solvents/${id}`, payload)
  },

  getRawMaterialEnzymesCatalysts(id) {
    return Repository.get(`/admin/supplier/raw_material/enz_cats/${id}`)
  },
  CreateRawMaterialEnzymesCatalysts(payload) {
    return Repository.post(`/admin/supplier/raw_material/enz_cats`, payload)
  },
  UpdateRawMaterialEnzymesCatalysts(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/enz_cats/${id}`, payload)
  },

  getRawMaterialGeneticallyModifiedOrganisms(id) {
    return Repository.get(`/admin/supplier/raw_material/gmos/${id}`)
  },
  CreateRawMaterialGeneticallyModifiedOrganisms(payload) {
    return Repository.post(`/admin/supplier/raw_material/gmos`, payload)
  },
  UpdateRawMaterialGeneticallyModifiedOrganisms(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/gmos/${id}`, payload)
  },

  getRawMaterialAllergens(id) {
    return Repository.get(`/admin/supplier/raw_material/allergens/${id}`)
  },
  CreateRawMaterialAllergens(payload) {
    return Repository.post(`/admin/supplier/raw_material/allergens`, payload)
  },
  UpdateRawMaterialAllergens(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/allergens/${id}`, payload)
  },

  getRawMaterialBaps(id) {
    return Repository.get(`/admin/supplier/raw_material/baps/${id}`)
  },
  CreateRawMaterialBaps(payload) {
    return Repository.post(`/admin/supplier/raw_material/baps`, payload)
  },
  UpdateRawMaterialBaps(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/baps/${id}`, payload)
  },

  getRawMaterialDerivatives(id) {
    return Repository.get(`/admin/supplier/raw_material/derivatives/${id}`)
  },
  CreateRawMaterialDerivatives(payload) {
    return Repository.post(`/admin/supplier/raw_material/derivatives`, payload)
  },
  UpdateRawMaterialDerivatives(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/derivatives/${id}`, payload)
  },

  getRawMaterialAdditional(id) {
    return Repository.get(`/admin/supplier/raw_material/add_infos/${id}`)
  },
  CreateRawMaterialAdditional(payload) {
    return Repository.post(`/admin/supplier/raw_material/add_infos`, payload)
  },
  UpdateRawMaterialAdditional(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/add_infos/${id}`, payload)
  },

  getRawMaterialStorage(id) {
    return Repository.get(`/admin/supplier/raw_material/storages/${id}`)
  },
  CreateRawMaterialStorage(payload) {
    return Repository.post(`/admin/supplier/raw_material/storages`, payload)
  },
  UpdateRawMaterialStorage(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/storages/${id}`, payload)
  },

  getRawMaterialPackagingTransport(id) {
    return Repository.get(`/admin/supplier/raw_material/pack_trans/${id}`)
  },
  CreateRawMaterialPackagingTransport(payload) {
    return Repository.post(`/admin/supplier/raw_material/pack_trans`, payload)
  },
  UpdateRawMaterialPackagingTransport(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/pack_trans/${id}`, payload)
  },

  getRawMaterialDietarySuitabilityItem(id) {
    return Repository.get(`/admin/supplier/raw_material/dietary_suitabilities/${id}`)
  },
  CreateRawMaterialDietarySuitabilityItem(payload) {
    return Repository.post(`/admin/supplier/raw_material/dietary_suitabilities`, payload)
  },
  UpdateRawMaterialDietarySuitabilityItem(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/dietary_suitabilities/${id}`, payload)
  },

  getRawMaterialProductTreatments(id) {
    return Repository.get(`/admin/supplier/raw_material/product_treatments/${id}`)
  },
  CreateRawMaterialProductTreatments(payload) {
    return Repository.post(`/admin/supplier/raw_material/product_treatments`, payload)
  },
  UpdateRawMaterialProductTreatments(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/product_treatments/${id}`, payload)
  },

  getRawMaterialLegislative(id) {
    return Repository.get(`/admin/supplier/raw_material/legislative_statuses/${id}`)
  },
  CreateRawMaterialLegislative(payload) {
    return Repository.post(`/admin/supplier/raw_material/legislative_statuses`, payload)
  },
  UpdateRawMaterialLegislative(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/legislative_statuses/${id}`, payload)
  },

  getRawMaterialGlobalSuitability(id) {
    return Repository.get(`/admin/supplier/raw_material/global_suitabilities/${id}`)
  },
  CreateRawMaterialGlobalSuitability(payload) {
    return Repository.post(`/admin/supplier/raw_material/global_suitabilities`, payload)
  },
  UpdateRawMaterialGlobalSuitability(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/global_suitabilities/${id}`, payload)
  },

  getRawMaterialSupportingDocumentation(id) {
    return Repository.get(`/admin/supplier/raw_material/supporting_documentations/${id}`)
  },
  CreateRawMaterialSupportingDocumentation(payload) {
    return Repository.post(`/admin/supplier/raw_material/supporting_documentations`, payload)
  },
  UpdateRawMaterialSupportingDocumentation(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/supporting_documentations/${id}`, payload)
  },

  getRawMaterialContaminantsPesticides(id) {
    return Repository.get(`/admin/supplier/raw_material/contaminant_pesticides/${id}`)
  },
  CreateRawMaterialContaminantsPesticides(payload) {
    return Repository.post(`/admin/supplier/raw_material/contaminant_pesticides`, payload)
  },
  UpdateRawMaterialContaminantsPesticides(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/contaminant_pesticides/${id}`, payload)
  },

  getCurrencyList() {
    return Repository.get('/admin/system_setting/currencies')
  },
  getUnitList() {
    return Repository.get('/admin/units')
  },

  getRawMaterialCommercialDetails(id) {
    return Repository.get(`/admin/supplier/raw_material/commercials/${id}`)
  },
  CreateRawMaterialCommercialDetails(payload) {
    return Repository.post(`/admin/supplier/raw_material/commercials`, payload)
  },
  UpdateRawMaterialCommercialDetails(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/commercials/${id}`, payload)
  },

  getRawMaterialCompanyData(id) {
    return Repository.get(`/admin/supplier/raw_material/company_datas/${id}`)
  },
  CreateRawMaterialCompanyData(payload) {
    return Repository.post(`/admin/supplier/raw_material/company_datas`, payload)
  },
  UpdateRawMaterialCompanyData(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/company_datas/${id}`, payload)
  },

  getRawMaterialStocks(id) {
    return Repository.get(`/admin/supplier/raw_material/stocks/${id}`)
  },
  CreateRawMaterialStocks(payload) {
    return Repository.post(`/admin/supplier/raw_material/stocks`, payload)
  },
  UpdateRawMaterialStocks(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/stocks/${id}`, payload)
  },

  getRmListForInventory(pageNumber = 1, pagination = defaultPagination, filterQuery, sort) {
    return Repository.get(`/admin/inventory/stock/raw_material_stocks?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  fetchRawMaterialCodes() {
    return Repository.get('/admin/supplier/raw_material_categories')
  },
  createRawMaterialCode(payload) {
    return Repository.post('/admin/supplier/raw_material_categories', payload)
  },

  setMarkAsComplete(id, payload) {
    return Repository.put(`/admin/supplier/raw_material/${id}/mark-completed`, payload)
  },
  getMarkCompleteList(id) {
    return Repository.get(`/admin/supplier/raw_material/${id}/mark-completed`)
  },

  // price change requests
  getListOfPriceChangeRequests(raw_material_id) {
    return Repository.get(`/admin/supplier/raw_material/price_change_requests?raw_material_id=${raw_material_id}`)
  },
  priceChangeRequestStatusChange(request_id, status, payload) {
    return Repository.put(`/admin/supplier/raw_material/price_change_request/${request_id}/${status}`, payload)
  },
  getPriceChangeRequestDetails(id) {
    return Repository.get(`/admin/supplier/raw_material/price_change_requests/${id}`)
  },

  downloadRawMaterialStockSheet() {
    return Repository.get(`/admin/export/report/raw-material-stock`, {
      responseType:'blob'
    })
  },
  downloadRawMaterialData(id) {
    return Repository.get(`/admin/export/staff/supplier/raw_material/${id}/attached-formulations`, {
      responseType:'blob'
    })
  },

};
